import { useQuery } from "@tanstack/react-query";
import api from "../utils/api";

export const fetchGetStudyByUser = async (userId) => {
  // 쿼리 파라미터가 추가된 URL로 API를 호출합니다.

  return await api.get(`/study-users/user/${userId}`);
};

export const useGetStudyByUserQuery = (userId) => {
  return useQuery({
    queryKey: ["students", userId],
    enabled: !!userId,
    queryFn: () => fetchGetStudyByUser(userId),
    select: (data) => {
      return data.data.data;
    },
    keepPreviousData: true,
  });
};
